import RegisterForm from "./components/RegisterForm";
import { Seo } from "@/components/specific/seo/Seo";
import { useSearchParams } from "react-router-dom";
import ConfirmEmail from "./components/ConfirmEmail";

export default function RegisterPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")
  const id = searchParams.get("id")
  
  return (
    <>
      <Seo title="Rejestracja" />
      {token && id && <ConfirmEmail id={id} token={token}/>}
      {!token && !id && <RegisterForm />}
    </>
  )
}
